// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';
import SelectStack from '../SelectStack';

export default class SpliceDocument extends Modal {
    
    state = {
        destination: "", 
        name: "", 
    }

    componentDidMount = () => {
        this.setState({
            destination: this.props.stack._id, 
            name: this.props.document.name 
        })
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <div style={{
                height: 150
            }} />

            <h1>Splice your document</h1>
            <p>Enter a new name for your document, and select that stack you would like to move it to.</p>

            <div style={{clear: "both"}}/>
            <h2>What's your new document called?</h2>
            <input
                id="splice-document-name"
                name="name"
                type="text"
                className={this.state.alert ? "input-error" : ""}
                placeholder="Enter document name..."
                style={{ width: 500 }}
                value={this.state.name}
                onClick={e => e.stopPropagation()}
                onChange={e => this.setState({ name: e.target.value.replace(/\//g, ""), alert: false })}
            />

            <h2>Where should we put your document?</h2>
            <SelectStack
                value={this.state.destination}
                onChange={selectedStack => this.setState({destination: selectedStack})}
                stacks={this.props.stacks}
                currentStackId={this.props.stack._id}
            />

            <div style={{ clear: 'both'}} />

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/reviewed.png')",
                    marginTop: 16
                }}
                onClick={() => {
                    this.props.spliceDocumentExec(this.state.name, this.state.destination, this.props.data.pages); 
                }}
            >
                Splice Document
            </div>
            
        </div>);
    }

};